import { useDispatch, useSelector } from "react-redux";
import {
  setDeleteProjectCandidateId,
  setShowDeleteProjectModal,
} from "@/store/projectsSlice";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { getAxiosErorrMessage, getUnexpiredToken } from "@/utils/utils";
import { toast } from "sonner";
import axios from "axios";
import { useNavigate } from "react-router";
import { useUser } from "@clerk/clerk-react";
import { useSession } from "@clerk/clerk-react";

import { useDatabaseSyncWrapperStore } from "../contexts/databaseSyncStore";

export const ProjectDeleteModal = () => {
  const { user } = useUser();
  const { session } = useSession();

  const navigate = useNavigate();

  const baseProjects = useSelector(
    (state: any) => state.supabaseStore.projects,
  );

  const dispatch = useDispatch<any>();

  const deleteProjectCandidateId = useSelector(
    (state: any) => state.projects.deleteProjectCandidateId,
  );
  const showDeleteProjectModal = useSelector(
    (state: any) => state.projects.showDeleteProjectModal,
  );

  const deleteProjectCandidate = baseProjects?.[deleteProjectCandidateId];

  const closeDeleteProjectModal = () => {
    dispatch(setShowDeleteProjectModal(false));
    dispatch(setDeleteProjectCandidateId(null));
  };

  const deleteProject = async (user) => {
    const supabaseJWT = await getUnexpiredToken(session);

    axios
      .post(
        `${
          import.meta.env.VITE_BACKEND_BASE_URL
        }/projects/${deleteProjectCandidateId}/deleteUser`,
        {},
        {
          headers: {
            Authorization: `Bearer ${supabaseJWT}`,
          },
        },
      )
      .then(() => {
        toast.success("Project deleted successfully");
        closeDeleteProjectModal();
        useDatabaseSyncWrapperStore.getState().triggerRefetchProjects();

        // Check if this was the last project and navigate to project creation if so
        // this is different from the first time no projects case where they go to project-create/workflow-select instead
        const remainingProjects = Object.keys(baseProjects || {}).filter(
          (id) => id !== deleteProjectCandidateId,
        );
        if (remainingProjects.length === 0) {
          navigate("/project-create/ai-new");
        }
      })
      .catch((err) => {
        toast.error(getAxiosErorrMessage(err));
      });
  };

  return (
    <AlertDialog
      open={showDeleteProjectModal}
      onOpenChange={(open: boolean) => {
        if (!open) {
          closeDeleteProjectModal();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xs font-normal">
            Delete Project
          </AlertDialogTitle>
          <AlertDialogDescription>
            <div className="w-full flex flex-col">
              <div className="pb-2 text-xs font-normal">
                Are you sure you want to delete this project?
              </div>
              <div className="flex flex-row gap-1">
                <div className="text-text-primary text-xs font-normal">
                  Project Name:
                </div>
                <div className="text-text-primary text-xs font-normal">
                  {deleteProjectCandidate?.name}
                </div>
              </div>
              <div className="flex flex-row gap-1">
                <div className="text-text-primary text-xs font-normal">
                  Repo URL:
                </div>
                <div className="text-text-primary text-xs font-normal">
                  {deleteProjectCandidate?.repoPath}
                </div>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => {
              closeDeleteProjectModal();
            }}
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={() => {
              deleteProject(user);
            }}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
